/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  contracts: [],
  total: 0,
  companySeq: 0,
  contractDownload: false,
  statusTokens: ['COMPLETED','ON_GOING','ON_PROCESSING','PROCESSING_FAILED','ABORTED'],
  statusInfo: [
    {text:'전체 건수', value:0, meta:'TOTAL', status:'', color:'text-success', size: 4},
    {text:'서명 완료', value:0, meta:'COMPLETED', status:'COMPLETED', color:'text-primary2', size: 4},
    {text:'내서명 필요', value:0, meta:'NEED_SIGNING', status:'NEED_SIGNING', color:'text-info', size: 4},
    {text:'광고주 서명 대기중', value:0, meta:'WAIT_FOR_SIGNING', status:'WAIT_FOR_SIGNING', color:'text-info', size: 4},
    // {text:'서명 후 취소', value:0, meta:'SIGNING_CANCELLED',status:'SIGNING_CANCELLED', color:'text-warning', size: 3},
    {text:'서명 취소', value:0, meta:'REQUEST_CANCELLED', status:'REQUEST_CANCELLED', color:'text-warning', size: 4},
    // {text:'거절됨', value:0, meta:'REJECTED',status:'REJECTED', color:'text-danger', size: 3},
  ]
};
